import Vue from "vue"

//'toasted-primary', 'outline', 'bubble Types: 'success, info, error
//auth success messages
export const logginSuccess = () => Vue.toasted.show('authenticated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end auth success messages

//role
export const roleCreateSuccess = () => Vue.toasted.show('role created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleUpdateSuccess = () => Vue.toasted.show('role updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleDeleteSuccess = () => Vue.toasted.show('role deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end role


//role modules
export const moduleCreateSuccess = () => Vue.toasted.show('module created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const moduleDeleteSuccess = () => Vue.toasted.show('module deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end modules

//permissions
export const permissionCreateSuccess = () => Vue.toasted.show('permission created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const permissionDeleteSuccess = () => Vue.toasted.show('permission deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end permissions

//user
export const userCreateSuccess = () => Vue.toasted.show('user created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userUpdateSuccess = () => Vue.toasted.show('user updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userDeleteSuccess = () => Vue.toasted.show('user deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignUserRoleModelSuccess = () => Vue.toasted.show('user asigned role module successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions asigned successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const removedRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions removed successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'info' });
export const uploadProfilePicSuccess = () => Vue.toasted.show('profile picture uploaded successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end users


//product
export const productCreateSuccess = () => Vue.toasted.show('product created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const productUpdateSuccess = () => Vue.toasted.show('product updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end product

//supplier
export const supplierCreateSuccess = () => Vue.toasted.show('supplier created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const supplierUpdateSuccess = () => Vue.toasted.show('supplier updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end supplier

//stock
export const stockCreateSuccess = () => Vue.toasted.show('stock created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const stockUpdateSuccess = () => Vue.toasted.show('stock updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end stock


//transporters
export const transporterCreateSuccess = () => Vue.toasted.show('transporter created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const transporterUpdateSuccess = () => Vue.toasted.show('transporter updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end transporters

//trucks
export const truckCreateSuccess = () => Vue.toasted.show('transporter truck created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const truckUpdateSuccess = () => Vue.toasted.show('transporter truck updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end trucks

//accounttypes
export const accounttypeCreateSuccess = () => Vue.toasted.show('account type created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const accounttypeUpdateSuccess = () => Vue.toasted.show('account type updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end accounttypes

//pettycash
export const pettycashCreateSuccess = () => Vue.toasted.show('petty cash amount created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end petty cash

//purchase orders
export const purchaseorderCreateSuccess = () => Vue.toasted.show('purchaseorder created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end purchase orders

//goods receiving note
export const goodsreceivingnoteCreateSuccess = () => Vue.toasted.show('goods receiving noted created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const goodsreceivingnoteUpdateSuccess = () => Vue.toasted.show('goods receiving noted updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end goods receiving note

//purchases
export const purchasesCreateSuccess = () => Vue.toasted.show('purchases created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end purchases

//sales
export const salesCreateSuccess = () => Vue.toasted.show('sales created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end sales

//expenses
export const expensesCreateSuccess = () => Vue.toasted.show('expenses created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end expenses

//labours
export const laboursCreateSuccess = () => Vue.toasted.show('labour charges created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const laboursUpdateSuccess = () => Vue.toasted.show('labour charges update successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end labours

//interchanges
export const interchangesCreateSuccess = () => Vue.toasted.show('interchanges created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end interchanges

//employees
export const employeeCreateSuccess = () => Vue.toasted.show('employee created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const employeeUpdateSuccess = () => Vue.toasted.show('employee  updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end employees

//occupation
export const occupationCreateSuccess = () => Vue.toasted.show('occupation created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const occupationUpdateSuccess = () => Vue.toasted.show('occupation updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end occupation

//employees
export const employeedeductionCreateSuccess = () => Vue.toasted.show('employee  deduction created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const employeedeductionUpdateSuccess = () => Vue.toasted.show('employee deduction updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end employees

//mileage
export const mileageCreateSuccess = () => Vue.toasted.show('mileage created successfully!', {icon: 'check', theme: 'outline', position: 'top-right', type: 'success'});
//end mileage

//attendances
export const attendanceCreateSuccess = () => Vue.toasted.show('attendances created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const attendanceUpdateSuccess = () => Vue.toasted.show('attendances  updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end attendances


//invoices
export const invoicesCreateSuccess = () => Vue.toasted.show('invoices created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end invoices


//cfs
export const cfsCreateSuccess = () => Vue.toasted.show('cfs created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const cfsUpdateSuccess = () => Vue.toasted.show('cfs updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end cfs

//cfs
export const destinationCreateSuccess = () => Vue.toasted.show('destination created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const destinationUpdateSuccess = () => Vue.toasted.show('destination updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end cfs

//jobcard
export const jobcardCreateSuccess = () => Vue.toasted.show('jobcard created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const jobcardUpdateSuccess = () => Vue.toasted.show('jobcard updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end jobcard

//truck attendances
export const truckattendanceCreateSuccess = () => Vue.toasted.show('truck attendances created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const truckattendanceUpdateSuccess = () => Vue.toasted.show('truck attendances  updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end truck attendances

//cfs
export const driversCreateSuccess = () => Vue.toasted.show('drivers created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const driversUpdateSuccess = () => Vue.toasted.show('drivers updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end cfs

//trucks
export const truckdocumentCreateSuccess = () => Vue.toasted.show('document truck created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const truckdocumentUpdateSuccess = () => Vue.toasted.show('document truck updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end trucks

//trucks
export const tripsdocumentCreateSuccess = () => Vue.toasted.show('trips created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const tripsdocumentUpdateSuccess = () => Vue.toasted.show('trips updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end trucks

//consignees
export const consigneesCreateSuccess = () => Vue.toasted.show('consignees created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const consigneesUpdateSuccess = () => Vue.toasted.show('consignees updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end consignees

//stations
export const stationsCreateSuccess = () => Vue.toasted.show('stations created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const stationsUpdateSuccess = () => Vue.toasted.show('stations updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end stations

//fuel
export const fuelCreateSuccess = () => Vue.toasted.show('truck fuel created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const fuelUpdateSuccess = () => Vue.toasted.show('truck fuel updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end fuel

//commission
export const commissionCreateSuccess = () => Vue.toasted.show('truck commission created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const commissionUpdateSuccess = () => Vue.toasted.show('truck commission updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end commission

//parking
export const parkingCreateSuccess = () => Vue.toasted.show('truck parking created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const parkingUpdateSuccess = () => Vue.toasted.show('truck parking updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end parking


// WEBPACK FOOTER //
// ./src/successmessages/success.js